export const SVG_HEIGHT = 420.67;
export const SVG_WIDTH = 300.14;
export const LINE_LENGTH = 240.18;
export const PADDING = 20;
export const NOOP = () => {};
export const FONT_NAME_ENUM = {
  "Nothing You Could Do": "From Me to You"
};
